import { Reveal } from "./Reveal";

export const SectionHeading = ({ chapter, title, subtitle, dark = false, testId }) => (
  <Reveal className="mb-16 md:mb-24">
    <div className="flex items-center gap-4 mb-8">
      <span className="h-px w-12 bg-sable" aria-hidden="true" />
      <span
        className={`font-accent text-xs font-medium tracking-[0.32em] uppercase ${dark ? "text-casse/60" : "text-anthracite/50"}`}
        data-testid={testId ? `${testId}-chapter` : undefined}
      >
        {chapter}
      </span>
    </div>
    <h2
      className={`font-heading font-semibold tracking-tight leading-snug text-3xl sm:text-4xl max-w-3xl ${dark ? "text-casse" : "text-nuit"}`}
      data-testid={testId ? `${testId}-title` : undefined}
    >
      {title}
    </h2>
    {subtitle && (
      <p
        className={`mt-6 text-base md:text-lg leading-relaxed max-w-2xl ${dark ? "text-casse/70" : "text-anthracite/70"}`}
        data-testid={testId ? `${testId}-subtitle` : undefined}
      >
        {subtitle}
      </p>
    )}
  </Reveal>
);
